// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5b79e08","513":"fedbf448","751":"f6b509d4"}[chunkId] + ".chunk.js";
};